import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { ThemeProvider, CssBaseline, Container, Box } from '@mui/material';
import theme from './theme';

// User Components
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import UserDashboard from './components/user/Dashboard';
import WorkoutTracker from './components/user/WorkoutTracker';
import WorkoutHistory from './components/user/WorkoutHistory';
import ExerciseLibrary from './components/user/ExerciseLibrary';
import UserProfile from './components/user/Profile';
import ProgressCharts from './components/user/ProgressCharts';
import Reminders from './components/user/Reminders';
import GoalsPage from './components/user/GoalsPage';

// Admin Components
import AdminDashboard from './components/admin/Dashboard';
import AdminExercises from './components/admin/Exercises';
import AdminUsers from './components/admin/Users';
import AdminStats from './components/admin/Stats';

// Layout Components
import Header from './components/layout/Header';
import Footer from './components/layout/Footer';
import Home from './components/layout/Home';
import NotFound from './components/layout/NotFound';
import Loading from './components/layout/Loading';
import PrivateRoute from './components/routing/PrivateRoute';
import AdminRoute from './components/routing/AdminRoute';

// Context
import AuthProvider from './context/AuthProvider';
import GoalProvider from './context/GoalProvider';

// CSS
import './App.css';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <GoalProvider>
          <Box 
            sx={{ 
              display: 'flex',
              flexDirection: 'column',
              minHeight: '100vh',
              bgcolor: 'background.default'
            }}
          >
            <Header />
            <Container component="main" sx={{ flexGrow: 1, py: 3, mt: 8 }}>
              <Routes>
              {/* Public Routes */}
              <Route path="/" element={<Home />} />
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              
              {/* User Routes */}
              <Route path="/dashboard" element={<PrivateRoute><UserDashboard /></PrivateRoute>} />
              <Route path="/workout" element={<PrivateRoute><WorkoutTracker /></PrivateRoute>} />
              <Route path="/history" element={<PrivateRoute><WorkoutHistory /></PrivateRoute>} />
              <Route path="/exercises" element={<PrivateRoute><ExerciseLibrary /></PrivateRoute>} />
              <Route path="/profile" element={<PrivateRoute><UserProfile /></PrivateRoute>} />
              <Route path="/progress" element={<PrivateRoute><ProgressCharts /></PrivateRoute>} />
              <Route path="/reminders" element={<PrivateRoute><Reminders /></PrivateRoute>} />
              <Route path="/goals" element={<PrivateRoute><GoalsPage /></PrivateRoute>} />
              
              {/* Admin Routes */}
              <Route path="/admin" element={<AdminRoute><AdminDashboard /></AdminRoute>} />
              <Route path="/admin/exercises" element={<AdminRoute><AdminExercises /></AdminRoute>} />
              <Route path="/admin/users" element={<AdminRoute><AdminUsers /></AdminRoute>} />
              <Route path="/admin/stats" element={<AdminRoute><AdminStats /></AdminRoute>} />
              
              {/* 404 Route */}
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Container>
          <Footer />
          <ToastContainer position="bottom-right" />
        </Box>
        </GoalProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
